<script>
	// Partials
	import List from '@/Partials/Promotions/_List.svelte';
	import UpdatePromotion from '@/Partials/Promotions/_Update.svelte';
	// Stores
	import PromotionStore from '@/Stores/PromotionStore';

	let updatePromotion = false;
	let selectedPromotion = null;

	export let promotionId = undefined;

	$: promotionId && $PromotionStore && loadPromotion();

	function loadPromotion() {
		selectedPromotion = $PromotionStore.firstWhere('id', promotionId.toString());
		updatePromotion = true;
	}

	let listComponent;
</script>

<div>
	<div class="flex">
		<List
			bind:selectedPromotion
			bind:this={listComponent}
			on:selected={() => {
				updatePromotion = true;
			}}
		/>
	</div>
</div>

{#if updatePromotion && selectedPromotion}
	{#key selectedPromotion}
		<UpdatePromotion
			bind:open={updatePromotion}
			promotion={selectedPromotion}
			on:updated={listComponent.getPromotions()}
		/>
	{/key}
{/if}
